import CompanyHierarchy from "../../../../components/company/organization/company-hierarchy";

export default function CompanyHierarchyPage(){
    return <CompanyHierarchy />
}